import { EVENT_TYPES } from '../../configs/constants';

export const updateSettings = settings => ({
  payload: settings,
  type: EVENT_TYPES.SETTINGS_UPDATE,
});

export default updateSettings;
